/** The palette behind a dynamic import, so its search and command code stays out of the root chunk until Mod-K. */
import { lazy, Suspense } from 'react';
import type { PaletteProps } from './palette.js';

const Loaded = lazy(() => import('./palette.js').then((m) => ({ default: m.Palette })));

export function LazyPalette(props: PaletteProps) {
  return (
    <Suspense fallback={null}>
      <Loaded {...props} />
    </Suspense>
  );
}
